<template>
  <div class="suppliers">
    <v-row>
      <v-col cols="12" md="8">
        <h1 class="text-left mx-4 mt-2">Suppliers</h1>
      </v-col>
      <v-col cols="12" md="4">
        <v-btn
          v-if="currentUser.privileges.canAddSuppliers"
          :to="{ name: 'AddSupplier' }"
          color="primary"
          class="mx-4 mt-2"
          rounded
          >Add Supplier</v-btn
        >
      </v-col>
    </v-row>
    <!-- <v-card class="mx-4 my-4">
      <v-card-title>
        All Suppliers
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
        <download-excel
            v-if="currentUser.privileges.canExportSuppliers"
          :fetch="getExportData"
          :fields="export_fields"
          :name="getExportName"
        >
          <v-btn
            class="ml-3 text-right"
            :loading="export_in_progress"
            :disabled="export_in_progress"
            color="white"
            elevation="1"
          >
            Export
            <v-icon right dark> mdi-export </v-icon>
            <template v-slot:loader>
              <span class="custom-loader">
                <v-icon light>mdi-cached</v-icon>
              </span>
            </template>
          </v-btn>
        </download-excel>
      </v-card-title> -->
      <!-- filter -->
      <!-- <v-row class="mx-4">
                <v-col cols="12" md="4">
                    <v-select
                    v-model="filter.category"
                    :items="categories"
                    small-chips
                    outlined
                    color="primary"
                    label="Filter by Category"
                    multiple
                    hide-details
                    dense
                    background-color="transparent"
                    item-value="code"
                    item-text="code"
                    class="mb-4 rounded-input"
                    @change="getAllFeeRecords()"
                    ></v-select>
                </v-col>

                <v-col cols="12" md="4">
                    <v-select
                    v-model="filter.room"
                    :items="rooms"
                    small-chips
                    outlined
                    color="primary"
                    label="Filter by Classroom"
                    multiple
                    hide-details
                    dense
                    background-color="transparent"
                    item-value="id"
                    item-text="sections"
                    class="mb-4 rounded-input"
                    @change="getAllFeeRecords()"
                    ></v-select>
                </v-col>
                <v-col cols="12" md="4">
                    <v-select
                    v-model="filter.status"
                    :items="['Paid', 'Due', 'Overdue', 'Upcoming']"
                    small-chips
                    outlined
                    color="primary"
                    label="Filter by Payment Status"
                    multiple
                    hide-details
                    dense
                    background-color="transparent"
                    class="mb-4 rounded-input"
                    @change="getAllFeeRecords()"
                    ></v-select>
                </v-col>
                </v-row> -->

      <!-- filter end -->
      <!-- <v-data-table
        :headers="supplier_headers"
        :items="suppliers"
        :items-per-page="-1"
        class="row-pointer"
        :search="search"
        hide-default-footer
        @click:row="clickSupplierRow"
      >
      </v-data-table>
    </v-card> -->
    <IntractDataTable
      title="All Suppliers"
      :headers="supplier_headers"
      :endpoint="endpointUrl"
      :export-fields="export_fields"
      :filter-fields="filterFields"
      search-parameter="query"
      order-parameter="o"
      :can-export="currentUser.privileges.canExportFeeAccounts"
      :enable-pagination="false"
      id="inventory-suppliers-table"
      @handleClick="clickSupplierRow"
    >
      <!-- <template v-slot:item.supplier_name="{ item }">
            <span class="font-weight-bold">{{ item.supplier_name }}</span>
      </template>
      <template v-slot:item.supplier_type="{ item }">
            <span class="font-weight-bold">{{ item.supplier_type.type_name }}</span>
      </template> -->
    </IntractDataTable>

    <v-snackbar v-model="snackbar.visible">
      {{ snackbar.text }}
      <template>
        <v-btn color="pink" text @click="snackbar.visible = false">Close</v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import api from "@api/index";
import { mapActions, mapGetters } from "vuex";
import endpoints from "@api/repository";
import Helper from "@utils/misc";
// import JsonExcel from "vue-json-excel";
import TourHelper from "@utils/tour_helper";
import IntractDataTable from "@components/widgets/generics/IntractDataTable";

export default {
  name: "Suppliers",
  data() {
    return {
      snackbar: {
        visible: false,
        text: "",
      },
      search: "",
      supplier_headers: [
        {
          text: "Name",
          value: "supplier_name",
          align: "center",
          sortable: true,
        },
        {
          text: "Supplier Type",
          value: "supplier_type.type_name",
          align: "center",
          sortable: false,
        },
        { text: "Phone", value: "phone_one", align: "center", sortable: false },
        { text: "Region", value: "region", align: "center", sortable: true },
      ],
      suppliers: [],
      export_in_progress: false,
      export_fields: {
        Name: "supplier_name",
        "Phone 1": "phone_one",
        "Phone 2": "phone_two",
        "Supplier Type": "supplier_type.type_name",
        Adress: "address",
        Region: "region",
        "Help Desk No.": "help_desk",
      },
      filterFields: {
        supplier: {
          model: null,
          items: [],
          label: "Filter by Type",
          itemValue: "supplier_type.id",
          itemText: "supplier_type.type_name",
          param: "type_id",
          endpoint: endpoints.suppliers,
        },
      },
    };
  },
  components: {
    // downloadExcel: JsonExcel,
    IntractDataTable
  },
  computed: {
    ...mapGetters(["currentUser", "accessToken", "isLoading"]),
    essentials() {
      return {
        accessToken: this.accessToken,
        setLoading: this.setLoading,
        handleErrorsFunction: this.handleApiErrors,
      };
    },
    getExportName() {
      return Helper.getExportName();
    },
    endpointUrl() {
      return Helper.addUrlParams(endpoints.suppliers);
    },
  },
  methods: {
    ...mapActions(["setLoading"]),

    handleTour() {
        var steps = [];
        steps.push({id: '1', title: "Supplier Details", description: "View and add supplier details in this section", videoLink: "https://youtube.com"});
        // steps.push({id: '2', title: "GRN", description: "Generate a GRN for a particular order", el: '#item-name'});
        TourHelper.startTour(this, "suppliers", steps);
    },
    
    async getAllSuppliers() {
      this.suppliers = await api.call(this.essentials, endpoints.suppliers);
      console.log(this.suppliers);
    },

    clickSupplierRow(supplier) {
      this.$router.push({ name: "EditSupplier", params: { id: supplier.id } });
    },

    // handles api errors
    async handleApiErrors(err) {
      this.setLoading(false);
      if (err.response) {
        console.log(err.response);
      } else {
        this.snackbar.text = "Unknown error occurred";
        this.snackbar.visible = true;
      }
    },

    async getExportData() {
      this.export_in_progress = true;
      var response;
      var url = endpoints.suppliers + "?extract=true";
      if (this.search) {
        url += (url.split("?")[1] ? "&" : "?") + "query=" + this.search;
      }

      response = await api.call(this.essentials, url);

      if (response) {
        this.export_in_progress = false;
        return response;
      }
    },
  },
  created() {
    this.getAllSuppliers();
    this.handleTour();
  },
};
</script>

<style scoped>
.row-pointer >>> tbody tr :hover {
  cursor: pointer;
}
</style>